<template>
    <header class="custom-WebsiteHeader WebsiteHeader Wrapper-header" v-if="websiteSettings">
        <div class="WebsiteHeader-container">
            <main class="WebsiteHeader-main">
                <div class="WebsiteHeader-logo">
                    <router-link :to="websiteHomeUrl" exact exact-active-class="on">
                        <img :src="websiteLogo" class="custom-WebsiteHeader-logo_image WebsiteHeader-logo_image" />
                    </router-link>
                </div>
                <div class="custom-WebsiteHeader-baseline WebsiteHeader-baseline">
                    <span v-html="websiteSettings.styles.subtitle" v-if="websiteSettings.styles.subtitle"></span>
                </div>
                <ShareContent class="WebsiteHeader-socials" v-if="shareableContent" />
            </main>
        </div>
    </header>
</template>

<script>
    import store from '@/store';

    export default {
        name: 'WebsiteHeader',
        components: {
            'ShareContent': () => import('@/components/ShareContent')
        },
        computed: {
            websiteSettings() {
                return store.state.websiteSettings;
            },
            websiteLogo() {
                return this.getLogo();
            },
            websiteHomeUrl() {
                if (this.$route.params.relmKey !== undefined) {
                    return {name:'home', params: {relmKey:this.$route.params.relmKey}};
                }
                return {name:'anonymous'}
            },
            shareableContent() {
                return this.$route.matched[0].props.default.shareable;
            }
        },
        watch: {
            websiteSettings: function () {
                this.getLogo();
            }
        },
        methods: {
            getLogo() {
                if (this.websiteSettings !== null && this.websiteSettings.styles.imageLogo !== undefined) {
                    return this.websiteSettings.styles.imageLogo;
                }
                return require('@/assets/websiteLogo.png');
            }
        }
    };
</script>
